// extracted by mini-css-extract-plugin
module.exports = {"btn":"FormButton_btn__oRHxY","forgetPassword":"FormButton_forgetPassword__3cLbQ","invalid":"FormButton_invalid__2QinG"};